import { render } from "./PointsOfInterestEditor.vue?vue&type=template&id=3353820c&scoped=true&ts=true&lang=pug"
import script from "./PointsOfInterestEditor.vue?vue&type=script&lang=ts&setup=true"
export * from "./PointsOfInterestEditor.vue?vue&type=script&lang=ts&setup=true"

import "./PointsOfInterestEditor.vue?vue&type=style&index=0&id=3353820c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3353820c"]])

export default __exports__